import { useRouter } from "@/utils";
import { getFiles } from "@/entities/DataAssociation/DataAssociation.queries";
import { useApiQuery } from "@/api/hooks";
import { useMemo } from "react";

export function useSelectedFile() {
    const router = useRouter();
    const { data: files, isLoading } = useApiQuery(getFiles);
    const selectedFileId = router.params.fileId;
    const selectedFile = useMemo(
        () =>
            selectedFileId
                ? files?.find((file) => file.id === selectedFileId)
                : null,
        [selectedFileId, files],
    );

    return {
        selectedFile,
        selectedFileId,
        isLoading: selectedFileId ? isLoading : false,
    };
}
